<script lang="ts">
	interface Props {
		inverse?: boolean;
	}

	let { inverse = false }: Props = $props();
</script>

<div class="lds-ring" class:inverse>
	<div></div>
	<div></div>
	<div></div>
	<div></div>
</div>

<style lang="postcss">
	@reference '../app.css';

	.lds-ring {
		display: inline-block;
		position: relative;
		width: 1rem;
		height: 1rem;

		&.inverse {
			div {
				@apply border-t-white-pure border-x-transparent border-b-transparent;
			}
		}
	}

	.lds-ring div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 1rem;
		height: 1rem;
		margin: 0px;
		border: 2px solid;
		border-radius: 50%;
		animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		@apply border-t-gray-dark border-x-transparent border-b-transparent;
	}
	.lds-ring div:nth-child(1) {
		animation-delay: -0.45s;
	}
	.lds-ring div:nth-child(2) {
		animation-delay: -0.3s;
	}
	.lds-ring div:nth-child(3) {
		animation-delay: -0.15s;
	}
	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
